import React from 'react';
import PropTypes from 'prop-types';
import { SovosReadOnlySlidingPanel } from 's1-ui/sovos-sliding-panel';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import {
  hintTextGrayColor,
  white,
  purpleDecorations
} from 'theme/mainColors';
import Typography from '@material-ui/core/Typography';
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon
} from '@material-ui/icons';
import { invoiceDynamicColumns } from './InvoiceDynamicColumns';

const columnNameItemStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  margin: '8px 0 8px 0',
  cursor: 'pointer'
};

class InvoiceColumnsSlidingPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    const updatedVisibleColumns = invoiceDynamicColumns
      .map(invoiceColumn => props.visibleInvoiceColumns
        .some(visibleColumn => visibleColumn.title === invoiceColumn.name)
        ? { ...invoiceColumn, visible: true }
        : { ...invoiceColumn, visible: false }
      );
    this.state = {
      disableApplyButton: true,
      invoiceColumnsList: updatedVisibleColumns,
      tempInvoiceColumnsList: updatedVisibleColumns
    };
  }

  handleCloseSlidingPanel = () => {
    this.setState({
      disableApplyButton: true,
      tempInvoiceColumnsList: [...this.state.invoiceColumnsList]
    });
    this.props.onClose();
  };

  toggleColumnVisibility = invoiceColumn => {
    const updatedInvoiceColumnsList = this.state.tempInvoiceColumnsList.map(column => 
      column.name === invoiceColumn.name 
        ? { ...column, visible: !column.visible }
        : { ...column }
    );
    this.setState({ tempInvoiceColumnsList: [...updatedInvoiceColumnsList], disableApplyButton: false });
  };

  handleApplyClick = () => {
    this.setState({ disableApplyButton: true, invoiceColumnsList: [...this.state.tempInvoiceColumnsList] });
    this.props.onToggleColumnsVisibility([...this.state.tempInvoiceColumnsList]);
    this.props.onGetExtraColumns( [...this.state.tempInvoiceColumnsList] );
    this.props.onClose();
  }
  
  render () {
    const { title, open, baseWidth } = this.props;
    const { tempInvoiceColumnsList } = this.state;
    return (
      <SovosReadOnlySlidingPanel
        title={ title }
        open={ open }
        onClose={ this.handleCloseSlidingPanel }
        baseWidth={ baseWidth }
        additionalButtons={ [
          <SovosButtonsGroup
            key="filter-additional-action-buttons"
            align="center"
            className="filter-additional-action-button"
          >
            <SovosRaisedButton
              key="apply-button"
              color={ white }
              backgroundColor={ purpleDecorations }
              onClick={ this.handleApplyClick }
              disabled={ this.state.disableApplyButton }
            >
              APPLY
            </SovosRaisedButton>
            <SovosRaisedButton
              key="cancel-button"
              color={ purpleDecorations }
              backgroundColor={ white }
              onClick={ this.handleCloseSlidingPanel }
            >
              CANCEL
            </SovosRaisedButton>
          </SovosButtonsGroup>
        ] }
      >
        {
          tempInvoiceColumnsList.map(invoiceColumn => (
            <div
              key={ invoiceColumn.name }
              style={ columnNameItemStyle }
              onClick={ () => this.toggleColumnVisibility(invoiceColumn) }
            >
              <Typography variant="subtitle2">
                { invoiceColumn.name }
              </Typography>
              {
                invoiceColumn.visible
                  ? <VisibilityIcon style={ { color: purpleDecorations } }/>
                  : <VisibilityOffIcon style={ { color: hintTextGrayColor } } />
              }
            </div>
          ))
        }
      </SovosReadOnlySlidingPanel>
    );
  }
}

InvoiceColumnsSlidingPanel.propTypes = {
  title: PropTypes.string.isRequired,
  baseWidth: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onToggleColumnsVisibility: PropTypes.func.isRequired,
  onGetExtraColumns: PropTypes.func,
  visibleInvoiceColumns: PropTypes.array.isRequired,
  classes: PropTypes.object
};

export default InvoiceColumnsSlidingPanel;


// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceColumnsSlidingPanel/InvoiceColumnsSlidingPanel.js